import { DateTime } from 'luxon'
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { TypographyStyles } from '@/styles'
import { Button, Separator, Text, Tooltip } from '@/ui'

export const TaxedAsToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="tax entity tips"
          iconRight={solid('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>

      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>Tax entities</Text>

        <Text>
          <b>Sole Proprietor</b> - You personally own and operate your business
          and your taxes are reported as personal income
        </Text>

        <Text>
          <b>S Corporation</b> - Your business’s corporate income, losses,
          deductions, and credit are passed through shareholders for federal tax
          purposes
        </Text>

        <Text>
          <b>C Corporation</b> - Your business’s owners, or shareholders, are
          taxed separately from the entity.
        </Text>

        <Separator />

        <Text>
          If none of the above applies or if you aren’t sure, select{' '}
          <b>Other</b>.
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}

export const BecomeSCorpToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="becoming an S Corporation"
          iconRight={regular('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>Becoming an S Corporation</Text>

        <Text>
          Was your business an S Corporation from January 1,{' '}
          {DateTime.now().year}, through December 31, {DateTime.now().year}? If
          you elected S Corporation status partway through the year, did you
          receive approval for full-year S Corporation status?
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}

export const CommingledBankingToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="commingled banking activity"
          iconLeft={regular('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>

      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>Commingled banking activity</Text>

        <Text>
          If you have personal and business transactions in the same bank
          account, select <b>Personal bank account</b>.
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}

export const SeperateBankingToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="separating your personal and business banking activity"
          iconLeft={regular('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>

      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>
          Separating your personal and business banking activity
        </Text>

        <Text>
          Paying for business and personal expenses from the same account puts
          your practice at risk.
        </Text>

        <Text>
          We&apos;ll guide you through separating your transactions after you’ve
          signed up.
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}

export const MultipleOwnersToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="multiple owners"
          iconLeft={regular('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>Multiple owners</Text>

        <Text>
          Select <b>yes</b> if you share ownership of your practice with anyone
          else, including your spouse.
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}

export const EmployeeCountToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="number of employees"
          iconLeft={regular('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>

      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>Number of employees</Text>

        <Text>
          If you have more than 10 full-time employees, select <b>Yes</b>.
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}

export const InternationalTaxToolTip = () => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Button
          aria-label="international taxes"
          iconLeft={regular('circle-info')}
          variant="discreet"
          size="square"
          className="w-4 h-4 pl-4"
        />
      </Tooltip.Trigger>

      <Tooltip.Content>
        <Text variant={TypographyStyles.H3}>International taxes</Text>

        <Text>
          If you see international clients and your practice pays taxes to
          countries other than the United States (including U.S. territories)
          select <b>Yes</b>.
        </Text>
      </Tooltip.Content>
    </Tooltip>
  )
}
